import { core_backend_url } from "../../config"

export const transfereeApi = {
    // 'getCertificates' : `${core_backend_url}certificate/certificates`,
    'uploadCertificate' : `${core_backend_url}certificate/upload/transferee`,
    'updateCertificate' : `${core_backend_url}certificate/upload/transferee/update`,
    'availableBanks': `${core_backend_url}certificate/get-available-banks`,
    'resendLinkToBank': `${core_backend_url}certificate/resend-link-to-bank-user`,
    'transfereeChangeStatus': `${core_backend_url}certificate/disbursement/approval/transferee`,
    'requestBalance': `${core_backend_url}certificate/transferee/request-for-balance`,
    'validateBankRep': `${core_backend_url}certificate/validate-bank-rep`
    // 'getComments' : (certificate_id) =>`${core_backend_url}certificate/${certificate_id}/comments`,
    // 'addComment' : `${core_backend_url}certificate/add-comment`,
    // 'getInboxLetters': `${core_backend_url}digital-letters/inbox`,
    // 'getSentLetters': `${core_backend_url}digital-letters/sent`,
    // 'getDraftLetters': `${core_backend_url}digital-letters/draft`,
    // 'sendLetter': `${core_backend_url}digital-letters/send`,
    // 'getUsers': `${core_backend_url}digital-letters/users`,
    // 'readLetter': (id) => `${core_backend_url}digital-letters/inbox/opened/${id}`,
    // 'deleteLetter': (id) => `${core_backend_url}digital-letters/inbox/delete/${id}`,
    // 'changeStatus': `${core_backend_url}certificate/change-status`
}